import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { PriorityFieldComponent } from '@features/priority-field/priority-field.component';

@Component({
    template: `
        <span class="priority flex">
            <app-priority-field [priority]="params.value" />
        </span>
    `,
    styleUrl: './priority-cell.component.scss',
    imports: [PriorityFieldComponent],
})
export class PriorityCellComponent implements ICellRendererAngularComp {
    public params!: ICellRendererParams;

    agInit(params: ICellRendererParams): void {
        this.params = params;
    }

    refresh() {
        return false;
    }
}
